module.exports = __webpack_public_path__ + "static/media/naira.babe0cc7.svg";